import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getSize, getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { parseThemeColor } from "./auth-service-tools206.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { getContrastColor } from "./auth-service-tools214.js";
import { getAutoContrastValue } from "./auth-service-tools215.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useCheckboxCardContext } from "./auth-service-tools324.js";
import { CheckboxIcon } from "./auth-service-tools320.js";
import classes from "./auth-service-tools325.js";
const defaultProps = {
  icon: CheckboxIcon
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    radius,
    color,
    size,
    iconColor,
    variant,
    autoContrast
  } = _ref;
  const parsedColor = parseThemeColor({
    color: color || theme.primaryColor,
    theme
  });
  const outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
  return {
    indicator: {
      "--checkbox-size": getSize(size, "checkbox-size"),
      "--checkbox-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--checkbox-color": variant === "outline" ? outlineColor : getThemeColor(color, theme),
      "--checkbox-icon-color": iconColor ? getThemeColor(iconColor, theme) : getAutoContrastValue(autoContrast, theme) ? getContrastColor({
        color,
        theme,
        autoContrast
      }) : void 0
    }
  };
});
const CheckboxIndicator = factory((_props, ref) => {
  const props = useProps("CheckboxIndicator", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    icon,
    indeterminate,
    radius,
    color,
    iconColor,
    autoContrast,
    checked,
    mod,
    variant,
    disabled,
    ...others
  } = props;
  const Icon = icon;
  const getStyles = useStyles({
    name: "CheckboxIndicator",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "indicator"
  });
  const ctx = useCheckboxCardContext();

  const _checked = typeof checked === "boolean" || typeof indeterminate === "boolean" ? checked || indeterminate : (ctx == null ? void 0 : ctx.checked) || false;

  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    ref,
    ...getStyles("indicator", {
      variant
    }),
    variant,
    mod: [{
      checked: _checked,
      disabled
    }, mod],
    ...others,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Icon, {
      indeterminate,
      ...getStyles("icon")
    })
  });
});
CheckboxIndicator.displayName = "@mantine/core/CheckboxIndicator";
CheckboxIndicator.classes = classes;
export { CheckboxIndicator };